import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Router } from '@angular/router';
import { environment } from '../../environments/environment';
import { ResponseFromExpress } from '../Interfaces/sqlresponses';
import { CustomerInformation } from '../Interfaces/customer-information';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class StoreService {
  constructor(public http: HttpClient, public router: Router) {}

  public UserNameConnected;
  public UserIdConnected;
  public AgentIdConnected;

  public OneClientInfo = null;
  public DocTypeName = null;
  public DocType = null;
  public DocTypeShrion = null;

  public OneClientInfoDebt;
  public AllOrdersDetailsClient = null;
  public TeudaNumForSeeTeudaInner;
  public TeudotPerClient;
  public EachClientEachOrder;
  public EachClientEachHov;

  public ProductInProductPage = null;
  public ProductInProductSectionToGoBack = null;
  public SpecPriceSs = null;
  public VCust = null;

  public ItemExtra = [];

  public BackFromClientCard = false;

  public TeudotDetails = null;

  public TeudotDetailsEach;
  public Teudot = null;
  public TeudotAll = null;
  public Betipul = 0;
  public MivzaA = null;

  public ClientFromDohot = 0;

  public SearchStyle = 1;

  public AllClientsTwoCompanys = [];

  public SeeTotalPrice;

  public ShowAshraiOnHovot;

  public AllTeudotAgent;

  public FromProductsToDohot = false;

  public CompanyNumForDuplicate;

  public OrderInProcess = false;

  public VersionNumber = 'V401.0';

  public SaveTeudotDohot = null;

  public AdminCompanyTeudot = 1;

  public NoObligoCheck = 0;

  public CheckMinPrice = 0;

  public HearotHeadForTeuda;

  public Heara1 = 0;
  public Heara2 = 0;
  public Heara3 = 0;
  public Heara4 = 0;
  public HearaNewOrder1 = '';
  public HearaNewOrder2 = '';
  public HearaNewOrder3 = '';
  public HearaNewOrder4 = '';

  public AllSavedMahlakot = null;
  public SaveMainGroups = null;

  public AllClientsHold = null;

  public AllClientsHoldSearch = 'חיפוש';
  public ClientForRETURN = 'null';

  public BlockMlayParam3 = true;
  public TeudaNumForMismachim;
  public AllMismachimClient;
  public SeeArizot = true;

  public AutoMoveHovot = 0;

  public AllProductsInfo = null;
  public AllProductsPricess = null;
  public ProductCompany = null;

  public BackToProductsFromTeuda = null;

  public BackToProductsFromTeudaSectionName = null;

  //CustNum From AgentList
  public CustNum;
  //CustomerInformation From Mobility
  public CustomerInformation = null;

  public Customers = null;

  public CustomerChoose = null;

  customers$ = new BehaviorSubject<CustomerInformation[]>([]);

  //=====================================================================================================================================================================================================================================================================>
  //=====================================================================================================================================================================================================================================================================>
  //=====================================================================================================================================================================================================================================================================>
  //=====================================================================================================================================================================================================================================================================>
  public UpdateName(body) {
    return this.http.post(environment.api_url + '/mobil/custname', body, {
      headers: { 'Content-type': 'application/json' },
      responseType: 'text',
    });
  }

  public UpdateNum(body) {
    return this.http.post(environment.api_url + '/mobil/custnum', body, {
      headers: { 'Content-type': 'application/json' },
      responseType: 'text',
    });
  }

  public UpdateServer(body) {
    return this.http.post(environment.api_url + '/mobil/custserver', body, {
      headers: { 'Content-type': 'application/json' },
      responseType: 'text',
    });
  }

  public UpdateImageDomain(body) {
    return this.http.post(
      environment.api_url + '/mobil/custimagedomain',
      body,
      {
        headers: { 'Content-type': 'application/json' },
        responseType: 'text',
      }
    );
  }

  public UpdateSeeImages(body) {
    return this.http.post(
      environment.api_url + '/mobil/UpdateSeeImages',
      body,
      {
        headers: { 'Content-type': 'application/json' },
        responseType: 'text',
      }
    );
  }

  public UpdateSeeImageGeneral(body) {
    return this.http.post(
      environment.api_url + '/mobil/UpdateSeeImageGeneral',
      body,
      {
        headers: { 'Content-type': 'application/json' },
        responseType: 'text',
      }
    );
  }

  public UpdateSeeArizot(body) {
    return this.http.post(
      environment.api_url + '/mobil/UpdateSeeArizot',
      body,
      {
        headers: { 'Content-type': 'application/json' },
        responseType: 'text',
      }
    );
  }

  public UpdateBlockParam3(body) {
    return this.http.post(
      environment.api_url + '/mobil/UpdateBlockParam3',
      body,
      {
        headers: { 'Content-type': 'application/json' },
        responseType: 'text',
      }
    );
  }

  public UpdateSeePrice(body) {
    return this.http.post(environment.api_url + '/mobil/UpdateSeePrice', body, {
      headers: { 'Content-type': 'application/json' },
      responseType: 'text',
    });
  }

  public UpdateChangeCss(body) {
    return this.http.post(
      environment.api_url + '/mobil/UpdateChangeCss',
      body,
      {
        headers: { 'Content-type': 'application/json' },
        responseType: 'text',
      }
    );
  }

  public UpdateChangeCss1(body) {
    return this.http.post(
      environment.api_url + '/mobil/UpdateChangeCss1',
      body,
      {
        headers: { 'Content-type': 'application/json' },
        responseType: 'text',
      }
    );
  }

  public UpdateAhuzAnaha(body) {
    return this.http.post(
      environment.api_url + '/mobil/UpdateAhuzAnaha',
      body,
      {
        headers: { 'Content-type': 'application/json' },
        responseType: 'text',
      }
    );
  }

  public DeleteClient(body) {
    return this.http.post(environment.api_url + '/mobil/DeleteClient', body, {
      headers: { 'Content-type': 'application/json' },
      responseType: 'text',
    });
  }

  public UpdateChangeCss2(body) {
    return this.http.post(
      environment.api_url + '/mobil/UpdateChangeCss2',
      body,
      {
        headers: { 'Content-type': 'application/json' },
        responseType: 'text',
      }
    );
  }

  public UpdateChangeCss3(body) {
    return this.http.post(
      environment.api_url + '/mobil/UpdateChangeCss3',
      body,
      {
        headers: { 'Content-type': 'application/json' },
        responseType: 'text',
      }
    );
  }

  public UpdateChangeCss4(body) {
    return this.http.post(
      environment.api_url + '/mobil/UpdateChangeCss4',
      body,
      {
        headers: { 'Content-type': 'application/json' },
        responseType: 'text',
      }
    );
  }

  public UpdateChangeCss5(body) {
    return this.http.post(
      environment.api_url + '/mobil/UpdateChangeCss4',
      body,
      {
        headers: { 'Content-type': 'application/json' },
        responseType: 'text',
      }
    );
  }

  //=====================================================================================================================================================================================================================================================================>
  //=====================================================================================================================================================================================================================================================================>
  //=====================================================================================================================================================================================================================================================================>
  //=====================================================================================================================================================================================================================================================================>
  //=====================================================================================================================================================================================================================================================================>
  //=====================================================================================================================================================================================================================================================================>
  //=====================================================================================================================================================================================================================================================================>
  //=====================================================================================================================================================================================================================================================================>
  //=====================================================================================================================================================================================================================================================================>
  //=====================================================================================================================================================================================================================================================================>
  //=====================================================================================================================================================================================================================================================================>
  //=====================================================================================================================================================================================================================================================================>
  //=====================================================================================================================================================================================================================================================================>
  //=====================================================================================================================================================================================================================================================================>
  //=====================================================================================================================================================================================================================================================================>
  //=====================================================================================================================================================================================================================================================================>
  //=====================================================================================================================================================================================================================================================================>
  //=====================================================================================================================================================================================================================================================================>
  //=====================================================================================================================================================================================================================================================================>
  public AddClient(body) {
    return this.http.post(
      environment.api_url + '/mobil/addclientdashbordnewnew',
      body,
      {
        headers: { 'Content-type': 'application/json' },
        responseType: 'text',
      }
    );
  }
  //=====================================================================================================================================================================================================================================================================>

  public GetAllMobilityClients() {
    return this.http.get<ResponseFromExpress<CustomerInformation>>(
      environment.api_url + '/mobility/mobilitymaindashbord'
    );
  }
  //=====================================================================================================================================================================================================================================================================>
  //=====================================================================================================================================================================================================================================================================>
  //=====================================================================================================================================================================================================================================================================>
  //check CustNum User (0) ---> (בדיקת מספר חברה בשרת מוביליטי)

  public GetCustInfo(CustomerNumber) {
    return this.http.get(
      environment.api_url + '/mobility/custinfo/' + CustomerNumber
    );
  }
  //==============================================================================================================================================>

  //Login User (1) ---> (התחברות למערכת)

  public loginService(UserName) {
    return this.http.get(
      this.CustomerInformation.CustServer + '/mobil/user/login/' + UserName
    );
  }

  //==============================================================================================================================================>

  //changed logged CONNECT (2) ---> ( שינוי התחברות ל 1 )

  public UpdateUserLoggedConnect(body) {
    return this.http.post(
      this.CustomerInformation.CustServer + '/mobil/changeconnlog',
      body,
      {
        headers: { 'Content-type': 'application/json' },
        responseType: 'text',
      }
    );
  }

  //==============================================================================================================================================>

  //changed logged DISCONNECT (3) ---> ( שינוי התחברות ל 0 )

  public UpdateUserLogged(body) {
    return this.http.post(
      this.CustomerInformation.CustServer + '/mobil/changelogged',
      body,
      {
        headers: { 'Content-type': 'application/json' },
        responseType: 'text',
      }
    );
  }

  //==============================================================================================================================================>

  //GetAllClients (4) ---> (כל הלקוחות)

  public GetAllClients() {
    return this.http.get(
      this.CustomerInformation.CustServer +
        '/mobil/user/clients' +
        '/' +
        this.AgentIdConnected
    );
  }

  //==============================================================================================================================================>

  //GetAllProducts (5) ---> (מוצרים לפתיחה על הדף)

  public GetAllProducts() {
    return this.http.get(
      this.CustomerInformation.CustServer +
        '/mobil/user/allproducts' +
        '/' +
        this.AgentIdConnected
    );
  }

  public GetAllProductsandpricesnew() {
    return this.http.get(
      this.CustomerInformation.CustServer +
        '/mobil/user/allproductspricessnew' +
        '/' +
        this.AgentIdConnected
    );
  }

  //==============================================================================================================================================>

  //GetAllProducts (6) ---> (כל המוצרים לאחר סינון)

  public GetVCust() {
    return this.http.get(
      this.CustomerInformation.CustServer +
        '/mobil/client/productsbyuser/' +
        this.OneClientInfo.ClientId +
        '/' +
        this.AgentIdConnected
    );
  }
  //==============================================================================================================================================>

  //GetAllProductsByNumberOfTimes (7) ---> (תדירות)

  public GetAllProductsnumoftimes() {
    return this.http.get(
      this.CustomerInformation.CustServer +
        '/mobil/user/products/byclientid/numoftimes/' +
        this.OneClientInfo.ClientId +
        '/' +
        this.AgentIdConnected +
        '/' +
        this.OneClientInfo.company
    );
  }

  //==============================================================================================================================================>

  //GetAllProductsByDocCreateDate (8) ---> (היסטוריה)

  public GetAllProductsdoccreatedate() {
    return this.http.get(
      this.CustomerInformation.CustServer +
        '/mobil/user/products/byclientid/doccreatedate/' +
        this.OneClientInfo.ClientId +
        '/' +
        this.AgentIdConnected +
        '/' +
        this.OneClientInfo.company
    );
  }

  //==============================================================================================================================================>

  //GetAllProductsByErp (9)  ---> (מוצרים חדשים)

  public GetAllProductserp() {
    return this.http.get(
      this.CustomerInformation.CustServer +
        '/mobil/user/products/byclientid/erp/' +
        this.OneClientInfo.ClientId +
        '/' +
        this.AgentIdConnected +
        '/' +
        this.OneClientInfo.company
    );
  }

  //==============================================================================================================================================>

  //GetllDocsType (10) ---> (סוגי תעודות)

  public GetDocsType() {
    return this.http.get(
      this.CustomerInformation.CustServer + '/mobil/user/docstype'
    );
  }

  //==============================================================================================================================================>

  //GetAllClientChoosenDebt (11) ---> (טבלת מספר תעודות חובות)

  public GetOneClientInfoDebt(ClientId) {
    return this.http.get(
      this.CustomerInformation.CustServer +
        '/mobil/user/clients/one/debt/' +
        ClientId +
        '/' +
        this.AgentIdConnected +
        '/' +
        this.OneClientInfo.company
    );
  }

  public GetAllClientsInfoDebt() {
    return this.http.get(
      this.CustomerInformation.CustServer +
        '/mobil/user/clients/all/debt/' +
        this.AgentIdConnected
    );
  }

  //==============================================================================================================================================>

  //GetAllClientChoosenDebtEachDebt (12) ---> (טבלת חוב לכל תעודת חוב לפי מספר תעודה)

  public SeeOneHovTeudaService(ClientId, DocDocNum) {
    return this.http.get(
      this.CustomerInformation.CustServer +
        '/mobil/user/clients/one/debt/teuda/' +
        ClientId +
        '/' +
        DocDocNum +
        '/' +
        this.AgentIdConnected +
        '/' +
        this.OneClientInfo.company
    );
  }

  //==============================================================================================================================================>

  //GetAllTeudotForOneClient (13) ---> (כל התעדות)

  public GetAllTeudot() {
    return this.http.get(
      this.CustomerInformation.CustServer +
        '/mobil/user/teudot/' +
        this.AgentIdConnected +
        '/' +
        this.OneClientInfo.ClientId
    );
  }

  //==============================================================================================================================================>

  //VerifyClientTeudaNumberForOrder (14) ---> (בירור מספר תעודה)

  public GetUpdatedNewNumber(number) {
    return this.http.get(
      this.CustomerInformation.CustServer + '/mobil/client/numbernew/' + number
    );
  }

  //==============================================================================================================================================>

  //UpdateClientTeudaNumberPlusOne (15) ---> (שינוי מספר תעודה +1)

  public ChangeNumber(body) {
    return this.http.post(
      this.CustomerInformation.CustServer + '/mobil/changenumber',
      body,
      {
        headers: { 'Content-type': 'application/json' },
        responseType: 'text',
      }
    );
  }

  //==============================================================================================================================================>

  //InsertItemsToTeuda (16) ---> (הכנסת ההזמנה לתעודה)

  public AllOrderString(body) {
    return this.http.post(
      this.CustomerInformation.CustServer + '/mobil/allorder',
      body,
      {
        headers: { 'Content-type': 'application/json' },
        responseType: 'text',
      }
    );
  }

  //==============================================================================================================================================>

  //get groups for products(17) ---> (קבלת מחלקות)

  public GetGroups() {
    return this.http.get(
      this.CustomerInformation.CustServer +
        '/mobil/user/productsgroups/' +
        this.AgentIdConnected
    );
  }

  //==============================================================================================================================================>

  //confirmed order(18) ---> ( אישור הזמנה)

  public CheckConfirmedOrder(number) {
    return this.http.get(
      this.CustomerInformation.CustServer +
        '/mobil/client/confirmedorder/' +
        number
    );
  }

  //==============================================================================================================================================>

  //get spec prices(19) ---> (מחירים מיוחדים)

  public GetAllPrices() {
    return this.http.get(
      this.CustomerInformation.CustServer +
        '/mobil/user/specprice/' +
        this.OneClientInfo.ClientId +
        '/' +
        this.AgentIdConnected +
        '/' +
        this.OneClientInfo.company
    );
  }

  public GetAllPricesAll() {
    return this.http.get(
      this.CustomerInformation.CustServer +
        '/mobil/user/specpriceall/' +
        this.AgentIdConnected
    );
  }

  public GetAllPricesDohot(ClientId, company) {
    return this.http.get(
      this.CustomerInformation.CustServer +
        '/mobil/user/specprice/' +
        ClientId +
        '/' +
        this.AgentIdConnected +
        '/' +
        company
    );
  }

  //==============================================================================================================================================>

  //comments(20) ---> (הערות)

  public GetHearotPerProduct(id) {
    return this.http.get(
      this.CustomerInformation.CustServer +
        '/mobil/user/productcomments/' +
        id +
        '/' +
        this.AgentIdConnected +
        '/' +
        this.OneClientInfo.company
    );
  }

  //==============================================================================================================================================>
  //teudot per agent(21) ---> (תעודות לסוכן)

  public GetAllTeudotPerAgentReport() {
    return this.http.get(
      this.CustomerInformation.CustServer +
        '/mobil/user/agentteudot/' +
        this.AgentIdConnected
    );
  }

  //==============================================================================================================================================>
  //teudot details per agent(22) ---> (  פרטי תעודות לסוכן  )

  public GetAllTeudotPerAgentReportDetails() {
    return this.http.get(
      this.CustomerInformation.CustServer +
        '/mobil/user/detailsagentteudot/' +
        this.AgentIdConnected
    );
  }

  //==============================================================================================================================================>
  //mivza  per client(23) ---> (    מבצעים  )

  public Mivza() {
    return this.http.get(
      this.CustomerInformation.CustServer +
        '/mobil/user/mivza/' +
        this.OneClientInfo.ClientId +
        '/' +
        this.AgentIdConnected +
        '/' +
        this.OneClientInfo.company
    );
  }
  //==============================================================================================================================================>
  //get shirion(24) ---> (שריון)

  public GetAllPricesShirion() {
    return this.http.get(
      this.CustomerInformation.CustServer +
        '/mobil/user/shirion/' +
        this.OneClientInfo.ClientId +
        '/' +
        this.AgentIdConnected +
        '/' +
        this.OneClientInfo.company
    );
  }

  public GetAllPricesShirionAll() {
    return this.http.get(
      this.CustomerInformation.CustServer +
        '/mobil/user/shirionall/' +
        this.AgentIdConnected
    );
  }
  //==============================================================================================================================================>
  //get companys(25) ---> (טבלת חברות)

  public GetComppanys() {
    return this.http.get(
      this.CustomerInformation.CustServer +
        '/mobil/user/companys' +
        '/' +
        this.AgentIdConnected
    );
  }
  //==============================================================================================================================================>
  //get doctypes per client(26) ---> ( סוגי תעודות ללקוח)

  public GetDoTypePerClient(ClientId, company) {
    return this.http.get(
      this.CustomerInformation.CustServer +
        '/mobil/user/doctypesperclient' +
        '/' +
        ClientId +
        '/' +
        this.AgentIdConnected +
        '/' +
        company
    );
  }

  public GetDoTypePerClientAll() {
    return this.http.get(
      this.CustomerInformation.CustServer +
        '/mobil/user/doctypesperclientall' +
        '/' +
        this.AgentIdConnected
    );
  }
  //==============================================================================================================================================>
  //get dOPen Checks per client(27) ---> ( צקים פתוחים ללקוח)

  public GetAllOpenChecksPerClient() {
    return this.http.get(
      this.CustomerInformation.CustServer +
        '/mobil/user/checks' +
        '/' +
        this.OneClientInfo.ClientId +
        '/' +
        this.AgentIdConnected +
        '/' +
        this.OneClientInfo.company
    );
  }
  //==============================================================================================================================================>
  //get dOPen Checks per client(27) ---> ( צקים פתוחים ללקוח)

  public GetSpecPricesForSave() {
    return this.http.get(
      this.CustomerInformation.CustServer + '/mobil/user/specpricesforsave'
    );
  }
  //==============================================================================================================================================>
  //mlay refresh  (28) ---> ( רענון מלאי  )

  public RefreshMlayService() {
    return this.http.get(
      this.CustomerInformation.CustServer + '/mobil/user/mlay'
    );
  }

  //==============================================================================================================================================>
  //Get Historya Parit(29) ---> ( היסטוריה פריט)

  public GetAllHistoryaParitClientService(ProductId) {
    return this.http.get(
      this.CustomerInformation.CustServer +
        '/mobil/user/historyaparit' +
        '/' +
        this.OneClientInfo.ClientId +
        '/' +
        this.AgentIdConnected +
        '/' +
        this.OneClientInfo.company +
        '/' +
        ProductId
    );
  }
  //==============================================================================================================================================>
  //==============================================================================================================================================>
  //==============================================================================================================================================>
  //==============================================================================================================================================>
  //==============================================================================================================================================>
  //==============================================================================================================================================>
  //==============================================================================================================================================>
  //==============================================================================================================================================>
  //==============================================================================================================================================>
  //==============================================================================================================================================>
  //==============================================================================================================================================>
  //==============================================================================================================================================>
  //==============================================================================================================================================>
  //==============================================================================================================================================>
  //==============================================================================================================================================>
  //==============================================================================================================================================>
  //==============================================================================================================================================>
  //get bizoim(30) ---> (ביצועים סוכן)

  public GetBizoim() {
    return this.http.get(
      this.CustomerInformation.CustServer +
        '/mobil/user/bizoimmonths' +
        '/' +
        this.AgentIdConnected
    );
  }
  //==============================================================================================================================================>
  //get bizoim lekohot(31) ---> (  ביצועים לקוחות)

  public GetBizoimLekohot() {
    return this.http.get(
      this.CustomerInformation.CustServer +
        '/mobil/user/bizoimlekohot' +
        '/' +
        this.AgentIdConnected
    );
  }

  public GetBizoimLekohotYear() {
    return this.http.get(
      this.CustomerInformation.CustServer +
        '/mobil/user/bizoimlekohotyear' +
        '/' +
        this.AgentIdConnected
    );
  }

  //==============================================================================================================================================>
  //get bizoim lekohot each(32) ---> ( כל אחד ביצועים לקוחות)

  public EachClientDohot(ClientId, Company, Month, Year) {
    return this.http.get(
      this.CustomerInformation.CustServer +
        '/mobil/user/bizoimeachclient' +
        '/' +
        ClientId +
        '/' +
        this.AgentIdConnected +
        '/' +
        Company +
        '/' +
        Month +
        '/' +
        Year
    );
  }

  public EachClientDohotYear(ClientId, AgentId, Company, Year) {
    return this.http.get(
      this.CustomerInformation.CustServer +
        '/mobil/user/bizoimeachclientyear' +
        '/' +
        ClientId +
        '/' +
        this.AgentIdConnected +
        '/' +
        Company +
        '/' +
        Year
    );
  }

  //==============================================================================================================================================>
  //get one teudat(33) ---> (תעודה אחת)

  public GetOneTeudaDohot(number) {
    return this.http.get(
      this.CustomerInformation.CustServer +
        '/mobil/user/oneteuda' +
        '/' +
        number
    );
  }

  //==============================================================================================================================================>
  //Historya Agent (34) ---> (היסטוריה סוכן)

  public GetAllTeudotAgentNew() {
    return this.http.get(
      this.CustomerInformation.CustServer +
        '/mobil/user/agenthistory' +
        '/' +
        this.AgentIdConnected
    );
  }

  public GetAllTeudotAgentNewClient(ClientId) {
    return this.http.get(
      this.CustomerInformation.CustServer +
        '/mobil/user/agenthistoryclient' +
        '/' +
        this.AgentIdConnected +
        '/' +
        ClientId
    );
  }

  //==============================================================================================================================================>
  //Historya Agent teuda(35) ---> (היסטוריה סוכן תעודה)

  public GetOneTeudaAgentNew(DocDocNum, Company) {
    return this.http.get(
      this.CustomerInformation.CustServer +
        '/mobil/user/teudahistory' +
        '/' +
        DocDocNum +
        '/' +
        Company +
        '/' +
        this.AgentIdConnected
    );
  }

  //==============================================================================================================================================>
  //==============================================================================================================================================>
  //==============================================================================================================================================>
  //changed admin true (36) ---> (הוספת מנהל דשבורד)

  public UpdateAdminOn(body) {
    return this.http.post(
      this.CustomerInformation.CustServer + '/mobil/adminon',
      body,
      {
        headers: { 'Content-type': 'application/json' },
        responseType: 'text',
      }
    );
  }
  //==============================================================================================================================================>
  //changed admin false (37) ---> ( הורדת מנהל דשבורד)

  public UpdateAdminOff(body) {
    return this.http.post(
      this.CustomerInformation.CustServer + '/mobil/adminoff',
      body,
      {
        headers: { 'Content-type': 'application/json' },
        responseType: 'text',
      }
    );
  }
  //==============================================================================================================================================>
  //changed order status admin (38) ---> ( שינוי סטטוס הזמנה ל 1 )

  public ConfirmOrderAdmin(body) {
    return this.http.post(
      this.CustomerInformation.CustServer + '/mobil/orderstatus',
      body,
      {
        headers: { 'Content-type': 'application/json' },
        responseType: 'text',
      }
    );
  }
  //==============================================================================================================================================>
  //bizoim gvia etc (38) ---> ( ביצועים גבייה )
  public GetBizoimGvia() {
    return this.http.get(
      this.CustomerInformation.CustServer +
        '/mobil/user/bizoimgvia' +
        '/' +
        this.AgentIdConnected
    );
  }

  public GetBizoimGviaYearSelected(Year) {
    return this.http.get(
      this.CustomerInformation.CustServer +
        '/mobil/user/bizoimyear' +
        '/' +
        this.AgentIdConnected +
        '/' +
        Year
    );
  }

  public GetBizoimGviaYearMonthSelected(Year, Month) {
    return this.http.get(
      this.CustomerInformation.CustServer +
        '/mobil/user/bizoimmonth' +
        '/' +
        this.AgentIdConnected +
        '/' +
        Year +
        '/' +
        Month
    );
  }
  //==============================================================================================================================================>
  //==============================================================================================================================================>
  //==============================================================================================================================================>
  //==============================================================================================================================================>
  //==============================================================================================================================================>
  //==============================================================================================================================================>
  //==============================================================================================================================================>
  //==============================================================================================================================================>
  //==============================================================================================================================================>
  //==============================================================================================================================================>
  //==============================================================================================================================================>
  //==============================================================================================================================================>
  //Admin Admin Admin Admin Admin Admin Admin Admin Admin Admin Admin Admin Admin Admin Admin Admin Admin Admin Admin Admin Admin Admin Admin Admin
  //admin get sales all agents(40) ---> ( מנהל מכירות כל הסוכנים)

  public AdminAgentsSales() {
    return this.http.get(
      this.CustomerInformation.CustServer + '/mobil/user/adminagentssales'
    );
  }

  //admin get sales all agents Second(41) ---> ( מנהל מכירות כל הסוכנים)

  public AdminAgentsSalesSecond(company) {
    return this.http.get(
      this.CustomerInformation.CustServer +
        '/mobil/user/adminagentssalessecond/' +
        company
    );
  }

  //admin get sales all agents Third(42) ---> ( מנהל מכירות כל הסוכנים)

  public AdminAgentsSalesThird(ag, company) {
    return this.http.get(
      this.CustomerInformation.CustServer +
        '/mobil/user/adminagentssalesthird' +
        '/' +
        ag +
        '/' +
        company
    );
  }

  //admin get sales all agents Third(42) ---> ( מנהל מכירות כל הסוכנים)

  public AdminAgentsSalesFourth(mm, YY, ag, cm) {
    return this.http.get(
      this.CustomerInformation.CustServer +
        '/mobil/user/adminagentssalesfourth' +
        '/' +
        mm +
        '/' +
        YY +
        '/' +
        ag +
        '/' +
        cm
    );
  }

  //==============================================================================================================================================>
  //Historya Agent (43) ---> (היסטוריה סוכן)

  public GetAllTeudotAdmin(Company) {
    return this.http.get(
      this.CustomerInformation.CustServer +
        '/mobil/user/adminhistory' +
        '/' +
        Company
    );
  }

  //==============================================================================================================================================>

  //Admin Admin Admin Admin Admin Admin Admin Admin Admin Admin Admin Admin Admin Admin Admin Admin Admin Admin Admin Admin Admin Admin Admin Admin
  //==============================================================================================================================================>
  //==============================================================================================================================================>
  //==============================================================================================================================================>
  //==============================================================================================================================================>
  //==============================================================================================================================================>
  //==============================================================================================================================================>
  //==============================================================================================================================================>
  //==============================================================================================================================================>
  //==============================================================================================================================================>
  //==============================================================================================================================================>
  //==============================================================================================================================================>
  //==============================================================================================================================================>
  //==============================================================================================================================================>
  //==============================================================================================================================================>
  //==============================================================================================================================================>
  //==============================================================================================================================================>
  //==============================================================================================================================================>
  //==============================================================================================================================================>
  //==============================================================================================================================================>
  //==============================================================================================================================================>
  //==============================================================================================================================================>
  //==============================================================================================================================================>
  //itempack (44) ---> ( אריזות )
  public GetPackOptionsService(ProductId) {
    return this.http.get(
      this.CustomerInformation.CustServer +
        '/mobil/user/itempack' +
        '/' +
        ProductId +
        '/' +
        this.OneClientInfo.company
    );
  }
  //==============================================================================================================================================>
  //Main Groups (45) ---> (ראשי מחלקות )

  public GetMainGroups() {
    return this.http.get(
      this.CustomerInformation.CustServer +
        '/mobil/user/maingroups' +
        '/' +
        this.AgentIdConnected +
        '/' +
        this.OneClientInfo.company
    );
  }
  //==============================================================================================================================================>
  //Second Groups (46) ---> (תת מחלקות )

  public SecondGroup(mg) {
    return this.http.get(
      this.CustomerInformation.CustServer +
        '/mobil/user/secondgroups' +
        '/' +
        this.AgentIdConnected +
        '/' +
        this.OneClientInfo.company +
        '/' +
        mg
    );
  }

  public SecondGroupSecond() {
    return this.http.get(
      this.CustomerInformation.CustServer +
        '/mobil/user/secondgroupssecond' +
        '/' +
        this.AgentIdConnected +
        '/' +
        this.OneClientInfo.company
    );
  }
  //==============================================================================================================================================>
  //Second Groups (47) ---> (הזמנות סוכן )

  public GetAllOrdersOneAgent() {
    return this.http.get(
      this.CustomerInformation.CustServer +
        '/mobil/client/getbitzoimorders/' +
        this.AgentIdConnected
    );
  }
  //==============================================================================================================================================>
  //ADMIN see agents per days  (48) ---> (הזמנות סוכן מנהל)

  public GetAgentsList() {
    return this.http.get(
      this.CustomerInformation.CustServer +
        '/mobil/client/adminseetotalagentsperday'
    );
  }
  //==============================================================================================================================================>
  //ADMIN see agents per days one agent one date  (49) ---> (שלב 2 הזמנות סוכן מנהל)

  public GetSpecificAgentAndDayService(ag, td, cm) {
    return this.http.get(
      this.CustomerInformation.CustServer +
        '/mobil/client/secondstepadminseetotalagentsperday' +
        '/' +
        ag +
        '/' +
        td +
        '/' +
        cm
    );
  }
  //==============================================================================================================================================>
  //ADMIN see agents per days one agent one date  (50) ---> (שלב 3 הזמנות סוכן מנהל)

  public GetOneAzmanaAgentAdmonDateService(tn) {
    return this.http.get(
      this.CustomerInformation.CustServer +
        '/mobil/client/oneazamana' +
        '/' +
        tn
    );
  }
  //==============================================================================================================================================>
  //ADMIN get products (51) ---> (מנהל - מוצרים)

  public GetAdminProducts() {
    return this.http.get(
      this.CustomerInformation.CustServer + '/mobil/admingetproducts'
    );
  }

  //==============================================================================================================================================>
  //==============================================================================================================================================>
  //ADMIN get numoftimes product - clients (52) ---> ( מנהל - מוצרים - לקוחות)

  public GetNumPfTimeAllClientsPerProductService(ProductId) {
    return this.http.get(
      this.CustomerInformation.CustServer +
        '/mobil/productnumoftimeclients' +
        '/' +
        ProductId
    );
  }
  //==============================================================================================================================================>
  //ADMIN get products teuda (53) ---> (מוצר - תעודה)

  public GetProductTeudaService(ProductId, ClientId) {
    return this.http.get(
      this.CustomerInformation.CustServer +
        '/mobil/productteudaadmin' +
        '/' +
        ProductId +
        '/' +
        ClientId
    );
  }
  //==============================================================================================================================================>
  //==============================================================================================================================================>
  //==============================================================================================================================================>
  //==============================================================================================================================================>
  //==============================================================================================================================================>

  //ADMIN get products teuda (54) ---> (ביקורים מנהל)

  public GetAllReportsAdmin() {
    return this.http.get(
      this.CustomerInformation.CustServer + '/mobil/bikoradmin'
    );
  }

  //ADMIN get products teuda (55) ---> (ביקורים סוכן)

  public GetAllReportsAgent() {
    return this.http.get(
      this.CustomerInformation.CustServer +
        '/mobil/bikoragent' +
        '/' +
        this.AgentIdConnected +
        '/' +
        this.OneClientInfo.ClientId +
        '/' +
        this.OneClientInfo.company
    );
  }

  //reasons no sale (56) ---> (סיבות אי מכירה סוכן)

  public GetAllReportsAgentReasons() {
    return this.http.get(
      this.CustomerInformation.CustServer +
        '/mobil/reasons' +
        '/' +
        this.AgentIdConnected +
        '/' +
        this.OneClientInfo.company
    );
  }

  //==============================================================================================================================================>
  //InsertItemsToTeuda (57) ---> (הכנסת ההזמנה לתעודה)

  public BikorConfirm(body) {
    return this.http.post(
      this.CustomerInformation.CustServer + '/mobil/bikorinsert',
      body,
      {
        headers: { 'Content-type': 'application/json' },
        responseType: 'text',
      }
    );
  }
  //==============================================================================================================================================>
  //get Hearot teuda (58) ---> (הערות תעודה)
  public GetHearotForTeuda() {
    return this.http.get(
      this.CustomerInformation.CustServer + '/mobil/hearotforteuda'
    );
  }
  //==============================================================================================================================================>
  //get hovot by month and year  (59) ---> ( חובות שנה חודש)

  public HovotByMonth(company, clientid) {
    return this.http.get(
      this.CustomerInformation.CustServer +
        '/mobil/yearmonthhovot/' +
        this.AgentIdConnected +
        '/' +
        company +
        '/' +
        clientid
    );
  }
  //==============================================================================================================================================>
  //get Hearot parit (60) ---> (הערות לפריט)

  public GetHearotPerProductClick(ProductId) {
    return this.http.get(
      this.CustomerInformation.CustServer +
        '/mobil/hearotforparit/' +
        this.OneClientInfo.company +
        '/' +
        this.AgentIdConnected +
        '/' +
        ProductId
    );
  }
  //==============================================================================================================================================>
  //headers type dohot for agent (61) ---> (כותרות דוחות לסוכן)

  public DinamicDohotFirst() {
    return this.http.get(
      this.CustomerInformation.CustServer +
        '/mobil/dohotdinamicagentheaders/' +
        this.AgentIdConnected
    );
  }
  //==============================================================================================================================================>
  //dohot for agent (62) ---> ( דוחות לסוכן)

  public DinamicDohotSecond(repn) {
    return this.http.get(
      this.CustomerInformation.CustServer +
        '/mobil/dohotdinamicagent/' +
        this.AgentIdConnected +
        '/' +
        repn
    );
  }
  //==============================================================================================================================================>
  //==============================================================================================================================================>
  //=====================================================================================================================================================================================================================================================================>
  //DASHBORD DASHBORD DASHBORD DASHBORD DASHBORD DASHBORD DASHBORD DASHBORD DASHBORD DASHBORD DASHBORD DASHBORD DASHBORD DASHBORD DASHBORD DASHBORD
  public GetTeudotDashbord() {
    return this.http.get<ResponseFromExpress<DashboardTeudotResponse>>(
      this.CustomerInformation.CustServer + '/mobil/client/dashbord'
    );
  }
  public GetTeudotDashbordCustomServer(server: string) {
    return this.http.get<ResponseFromExpress<DashboardTeudotResponse>>(
      server + '/mobil/client/dashbord'
    );
  }

  public GetTeudotEach(TeudaNum) {
    return this.http.get(
      this.CustomerInformation.CustServer + '/mobil/' + TeudaNum
    );
  }

  public GetTeudotFirst(TeudaNum) {
    return this.http.get(
      this.CustomerInformation.CustServer + '/mobil/dash/' + TeudaNum
    );
  }

  public GetAllAgents() {
    return this.http.get(
      this.CustomerInformation.CustServer + '/mobil/user/all'
    );
  }
  public GetAllAgentsCustomServer(server: string) {
    return this.http.get(server + '/mobil/user/all');
  }
  //DASHBORD DASHBORD DASHBORD DASHBORD DASHBORD DASHBORD DASHBORD DASHBORD DASHBORD DASHBORD DASHBORD DASHBORD DASHBORD DASHBORD DASHBORD DASHBORD
  //=====================================================================================================================================================================================================================================================================>
  //==============================================================================================================================================>
  //==============================================================================================================================================>
  //==============================================================================================================================================>
  //==============================================================================================================================================>
  //==============================================================================================================================================>
  //==============================================================================================================================================>
  //=====================================================================================================================================================================================================================================================================>

  //!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!
}

//!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!

export type DashboardTeudotResponse = {
  SupplyDate: string;
  TeudaNum: string;
  TeudaType: number;
  AgentID: string;
  TeudaDate: string;
  TeudaStatus: number;
  Status: number;
  Client_Name: string;
  TeudaTotalSum: number;
  TotalLines: number;
  TeudaRemark: string;
  Company: number;
  TeudaNewNum: string;
  TuedaErpDocNum: string;
  Num1: string;
  Type1: number;
  TeudaShowDate: string;
  TeudaShowTime: string;
  Obligo: number;
};
